import { render, staticRenderFns } from "./displayData.vue?vue&type=template&id=a2e354e2&"
import script from "./displayData.vue?vue&type=script&lang=js&"
export * from "./displayData.vue?vue&type=script&lang=js&"
import style0 from "./displayData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports